import { ACCENT_PRESETS } from './bannerOptions';
import { readableAccent } from './appCardMirror';
import { FieldLabel } from './bannerFormBits';

/** The card's colour: one row of swatches, or anything else through Custom. */
export function AccentPicker({ value, onChange }: { value: string; onChange: (hex: string) => void }) {
  return (
    <div>
      <FieldLabel
        text="Accent colour"
        hint="Colours the left stripe, the countdown and a faint background tint. The app's own theme does not change."
      >
        {/* Anything not in the palette. A very light pick still renders readably — the
            card darkens the accent for text only. */}
        <label className="inline-flex flex-none cursor-pointer items-center gap-1.5 text-xs text-gray-600">
          <input
            type="color"
            value={value}
            onChange={(e) => onChange(e.target.value.toUpperCase())}
            className="h-[18px] w-[18px] cursor-pointer appearance-none rounded border-0 bg-transparent p-0 [&::-moz-color-swatch]:rounded [&::-moz-color-swatch]:border-0 [&::-webkit-color-swatch-wrapper]:p-0 [&::-webkit-color-swatch]:rounded [&::-webkit-color-swatch]:border-0"
          />
          <span className="font-mono text-gray-500">{value}</span>
          Custom
        </label>
      </FieldLabel>
      <div className="grid grid-cols-8 justify-items-center gap-2 sm:flex sm:justify-between sm:gap-0">
        {ACCENT_PRESETS.map((c) => (
          <button
            key={c.value}
            type="button"
            aria-pressed={value.toLowerCase() === c.value.toLowerCase()}
            onClick={() => onChange(c.value)}
            title={c.label}
            className={`h-6 w-6 rounded-full transition-transform ${
              value.toLowerCase() === c.value.toLowerCase()
                ? 'outline outline-2 outline-offset-1 outline-gray-900'
                : 'hover:scale-110'
            }`}
            style={{ backgroundColor: c.value }}
          />
        ))}
      </div>
      {readableAccent(value).toLowerCase() !== value.toLowerCase() && (
        <p className="mt-1 text-xs text-amber-700">
          Light colour — text on the card will be darkened to stay readable.
        </p>
      )}
    </div>
  );
}
